import { Static, Type } from "@sinclair/typebox";
import { User } from "./User";
import { Person } from "./Person";
import { LayoutFieldsSetup } from "./LayoutFieldsSetupType";
import { ThreadMessagesResponse } from "./ThreadMessagesResponse";
import { LeadStatus } from "./LeadStatus";
import { Opp, OppsOrder } from "./SfQueryApiResponse";
import { ApiErrorResponse } from "./ApiErrorResponse";
import { WhatsllyGroup } from "./WhatsllyGroup";

export const QUERY_RESPONSE_ERROR_TYPES = {
  UPDATE_VERSION: "UPDATE_VERSION",
  USER_WITHOUT_PERMISSION: "USER_WITHOUT_PERMISSION",
  USER_MISSING_PERMISSION: "USER_MISSING_PERMISSION",
  GROUPS_NOT_SUPPORTED: "GROUPS_NOT_SUPPORTED",
  EXTENSION_NOT_SUPPORTED: "EXTENSION_NOT_SUPPORTED",
  USER_NOT_SUPPORTED: "USER_NOT_SUPPORTED",
} as const;

const MatchedBy = Type.Union([Type.Literal("PHONE"), Type.Literal("NAME")]);

export type MatchedByType = Static<typeof MatchedBy>;

const QueryResponseSuccess = Type.Object({
  etoken: Type.Optional(Type.String()),
  user: Type.Optional(User),
  wPod: Type.String(),
  fields: Type.Optional(LayoutFieldsSetup),
  logoUrl: Type.Optional(Type.String()),
  person: Type.Union([Person, Type.Array(Person)]),
  success: Type.Literal(true),
  isGroup: Type.Optional(Type.Literal(true)),
  whatslly_person_id: Type.Optional(Type.String()),
  matchedBy: Type.Optional(MatchedBy),
  foundMultiple: Type.Optional(Type.Boolean()),
  msgs: Type.Optional(ThreadMessagesResponse),
  leadStatus: Type.Optional(Type.String()),
  leadStatuses: Type.Optional(Type.Array(LeadStatus)),
  oppsOrder: Type.Optional(Type.Array(OppsOrder)),
  opps: Type.Optional(Type.Array(Opp)),
  openOpps: Type.Optional(Type.Array(Opp)),
  originalRecordAmount: Type.Optional(Type.Number()),
  engagementId: Type.String(),
  group: Type.Optional(WhatsllyGroup),
  foundByDefault: Type.Optional(Type.Boolean()),
});

export const QueryResponse = Type.Union([ApiErrorResponse, QueryResponseSuccess]);

export type SuccessfullQueryResponse = Static<typeof QueryResponseSuccess>;
export type QueryResponseType = Static<typeof QueryResponse>;
